/* eslint-disable jsx-a11y/anchor-is-valid */
// @ts-nocheck
import React, { useState, useEffect, useContext, Suspense, useRef } from 'react';
import { Row, Col, Card, Form, Input, DatePicker, Select, Button, AutoComplete, Modal, Spin } from 'antd';
import { useHistory } from 'react-router-dom';
import { 
    PrinterOutlined, 
    SyncOutlined, 
    SnippetsOutlined, 
    RollbackOutlined, 
    SaveOutlined, 
    StopOutlined,
    ExclamationCircleOutlined,
} from '@ant-design/icons';



import PageTitle from 'shared_components/page_title';
import DeliveryDataTable from './delivery_dataTable';
import './delivery_data_entry.css';
import { numberFormat } from 'utils/helper';
import {
    createDeliveryAPI, 
    updateDeliveryAPI, 
    fetchCustomerDetailsAPI, 
    fetchDrListAPI, 
    fetchDeliveryDetailsAPI,
    deleteDrDetailsAPI, 
    generateDeliveryReport, 
    fetchDeliveryHeaderAPI, 
    fetchDeliveryNoAPI,
    // drPrintedTrxnAPI
} from 'services/delivery_receipts/delivery_receipts';
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';
import { 
    fetchCustomersListAPI, 
    fetchDelAddListAPI, 
    fetchTermsListAPI, 
    fetchStatusListAPI,
	fetchMessageListAPI,
    fetchAgentsListAPI,
} from 'services/shared/fetchLovList';

import Message from 'shared_components/message';
import moment from 'moment';
import { AlphaNumInput } from 'shared_components/pattern_input';
import { RegexInput } from 'shared_components/pattern_input';
import { toUpper, upperCase } from 'lodash';
import { UserAccessContext } from 'context/userAccess';

const { Option } = Select;
const { TextArea } = Input;

const footerStyleRight = {
	textAlign: 'right',
};

const buttonStyle = {
	background: '#0487C8',
	border: '#0487C8',
};

const formItemStyle = { paddingBlock: 0, marginBlock: 4, borderBlock: 0 };

function formatQuantityForPrint(quantity) {
    if (quantity === null || quantity === undefined || quantity === '') return null;

    const rawQuantity = String(quantity).replace(/,/g, '').trim();
    if (rawQuantity === '') return null;

    const numericQuantity = Number(rawQuantity);
    if (Number.isNaN(numericQuantity)) return String(quantity);
    if (numericQuantity === 0) return null;

    const [integerPart, decimalPart] = rawQuantity.split('.');
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    if (decimalPart === undefined || decimalPart === '') {
        return formattedInteger;
    }

    return `${formattedInteger}.${decimalPart}`;
}

function formatAmountForPrint(amount) {
    if (amount === null || amount === undefined || amount === '') return '0.00';

    const rawAmount = String(amount).replace(/,/g, '').trim();
    if (rawAmount === '') return '0.00';

    const numericAmount = Number(rawAmount);
    if (Number.isNaN(numericAmount)) return String(amount);

    return numericAmount.toFixed(2);
}

function getApiErrorMessage(error, fallbackMessage = 'Something went wrong.') {
    const responseData = error && error.response ? error.response.data : null;

    if (typeof responseData === 'string' && responseData.trim() !== '') {
        return responseData;
    }

    if (responseData && typeof responseData.message === 'string' && responseData.message.trim() !== '') {
        return responseData.message;
    }

    if (error && typeof error.message === 'string' && error.message.trim() !== '') {
        return error.message;
    }

    return fallbackMessage;
}

function resolveAgentIdFromRecord(record, agentList = []) {
    if (!record || !Array.isArray(agentList) || agentList.length === 0) return undefined;

    const explicitAgentId = record.agent_id;
    if (explicitAgentId !== undefined && explicitAgentId !== null && explicitAgentId !== '') {
        return explicitAgentId;
    }

    const recordAgentName = [record.agent_name, record.agent, record.sales_man]
        .find(value => value !== undefined && value !== null && String(value).trim() !== '');

    if (!recordAgentName) return undefined;

    const normalizedRecordAgentName = String(recordAgentName).trim().toUpperCase();
    const matchedAgent = agentList.find(item => {
        const possibleNames = [item.agent_name, item.agent]
            .filter(value => value !== undefined && value !== null && String(value).trim() !== '')
            .map(value => String(value).trim().toUpperCase());

        return possibleNames.includes(normalizedRecordAgentName);
    });

    return matchedAgent ? matchedAgent.agent_id : undefined;
}

export default function DeliveryDataEntry(props) {
	const drDetProps =  (props.deliveryDetails === 'undefined' ? '' : props.deliveryDetails);
    const { userAccess } = useContext(UserAccessContext);
	const navigate = useHistory();
    const [ isloading, setLoading ] = useState(true);
    const [ printLoading, setPrintLoading ] = useState(false);
	const [form] = Form.useForm();
    const [drData, setDrData] = useState([]);
    const [drDetails, setDrDetails] = useState([]);
    const [detailsData, setDetailsData] = useState([]);
    const detailsDataRef = useRef([]);
    const [deliverToDisabled, setDeliverToDisabled] = useState(true);
    const [allDisabled, setAllDisabled] = useState(false);
    const [checkPost, setCheckPost] = useState(true);
    const [agentsList, setAgentsList] = useState([]);
    const [customersList, setCustomersList] = useState([]);
    const [termsList, setTermsList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [messagesList, setMessagesList] = useState([]);
	const loggedinUser = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA));
    const [deliveryAddList, setDeliveryAddList] = useState([]);
    const [contactPersonList, setContactPersonList] = useState([]);
    const [deleteList, setDeleteList] = useState([]);
    const [customerDetList, setCustomerDetList] = useState([]);
    const [edit, setEdit] = useState(false);
    const [drStatus, setDrStatus] = useState();
    const [hasLoadedDetails, setHasLoadedDetails] = useState(false);

    const cancelDRRight = userAccess['deliveryReceipt'].cancel;
    const postDRRight = userAccess['deliveryReceipt'].post;
    const printDRRight = userAccess['deliveryReceipt'].print;
    const updateDRRight = userAccess['deliveryReceipt'].update;
    const overrideDRRight = userAccess['deliveryReceipt'].override;
    
	async function getLOVList(){
        try{
            const agents = await fetchAgentsListAPI();
            const customers = await fetchCustomersListAPI();
            const terms = await fetchTermsListAPI();
            const status = await fetchStatusListAPI('DELIVERY_RECEIPTS'); // in status list indicate used_by value. e.g. "INVOICES"
            const drNo = await fetchDrListAPI();
			const messages = await fetchMessageListAPI();           
            const customerDet = await fetchCustomerDetailsAPI();

            setAgentsList(agents);
		    setMessagesList(messages);
            setCustomersList(customers);
            setTermsList(terms);
            setStatusList(status);
            setCustomerDetList(customerDet);

            if(messages){
                setLoading(false);
            };
        }catch(error) {
            console.log("error", error);
        }
    };

	useEffect( ()=> {
        function fetchData() {
            getLOVList();
        }
        fetchData();

    }, []);

    useEffect(()=> {
        setCheckPost(checkPost);
    },[checkPost]);

    useEffect(() => {
        if (!props.isEditting || !drDetProps || agentsList.length === 0) return;

        const currentAgentValue = form.getFieldValue('agentID');
        if (currentAgentValue !== undefined && currentAgentValue !== null && currentAgentValue !== '') return;

        const resolvedAgentId = resolveAgentIdFromRecord(drDetProps, agentsList);
        if (resolvedAgentId !== undefined && resolvedAgentId !== null && resolvedAgentId !== '') {
            form.setFieldsValue({ agentID: resolvedAgentId });
        }
    }, [props.isEditting, drDetProps, agentsList, form]);

    const deliverToOptions = customersList.map((item, index) => {
        return(
            <Option key={item.customer_id} value={item.customer_val}>{item.customer}</Option>
            
        ); 
    });
    
	//get terms list
	const termsOptions = termsList.map((item, index) => {
        return(
            <Option key={index} value={item.term_id}>{item.term_name}</Option>
        ); 
    });
     
	//get status list
	const statusOptions = statusList.map((item, index) => {
        return(
            <Option key={index} value={item.status_id}>{item.status_name}</Option>
        ); 
    });

    const agentsOptions = agentsList.map((item, index)=>{
        const {agent_id, agent, agent_name} = item;
        return (
            <Option key={agent_id} value={agent_id} agentName={agent_name}>{agent}</Option>
        );
    });

    
    //delivery address list
    const addressOptions = deliveryAddList.sort((a, b) => a.delivery_address.localeCompare(b.delivery_address)).map((item, index) => {
        return(
            <Option key={index} value={item.delivery_address}>{item.delivery_address.toUpperCase()}</Option>
        ); 
    });
    // get contact person from delivery address
    const contactpersonOptions = contactPersonList.map((item, index) => {
        return(
            <Option key={index} value={item.contact_person}>{item.contact_person.toUpperCase()}</Option>
        ); 
    });

	async function getDeliveryDetails() {
        const drID = drDetProps.dr_id;

        try{
            const getDrDet = await fetchDeliveryDetailsAPI(drID);
            setDrDetails(getDrDet);
            setHasLoadedDetails(true);

        }catch(error) {
            console.log("get delivery details error", error)
        }
    }

    // delivery details and update
    useEffect(() => {
        if(props.isEditting && !hasLoadedDetails){
            if(drDetProps.status_name === 'POSTED' || drDetProps.status_name === 'CANCELLED' || updateDRRight === 'FALSE'){
                setDeliverToDisabled(true);
                setAllDisabled(true);

                getDeliveryDetails();
            }else{
                setDeliverToDisabled(false);
                setAllDisabled(false);
                getDeliveryDetails();
            }
        }

        // console.log('drDetProps =>', drDetProps);

        if(drDetProps !== undefined){
            setDrStatus(drDetProps.status_name);
        }
	}, [props, drDetProps]);

	function handleTotVal(payload){
		form.setFieldsValue({totalAmount: numberFormat(payload,2) })
	};

	//handle Delivered To
	async function handleDeliverToOnChange(value) {
        if(!props.isEditting){
            setDeliverToDisabled(false);
        }

        try{
            const selectedCustomer = customersList.find(items => items.customer_val === value);

            if (!selectedCustomer) {
                setDeliveryAddList([]);
                form.setFieldsValue({
                    terms: '',
                    deliveryAddress: '',
                    agentID: undefined,
                });
                return;
            }

            const custDet = customerDetList.filter(
                items => items.customer_id === selectedCustomer.customer_id,
            );
            const deliveryAddDet = await fetchDelAddListAPI(selectedCustomer.customer_id);
            
            let deliveryAdd, sales = '';

            if(deliveryAddDet.length > 0){
                setDeliveryAddList(deliveryAddDet);

                deliveryAdd = deliveryAddDet[0].delivery_address === undefined ? null : deliveryAddDet[0].delivery_address;
                sales = deliveryAddDet[0].contact_person === undefined ? null : deliveryAddDet[0].contact_person;
            }else{
                setDeliveryAddList([]);
            }

            const customerAgentId =
                custDet.length > 0 && custDet[0].agent_id !== null && custDet[0].agent_id !== undefined
                    ? custDet[0].agent_id
                    : undefined;
            const customerTermId =
                custDet.length > 0 && custDet[0].term_id !== null && custDet[0].term_id !== undefined
                    ? custDet[0].term_id
                    : '';

            const fallbackAgentIdForEdit = props.isEditting ? form.getFieldValue('agentID') : undefined;
            const nextAgentId =
                customerAgentId !== undefined ? customerAgentId : fallbackAgentIdForEdit;

            form.setFieldsValue({
                terms: customerTermId,
                deliveryAddress: deliveryAdd === null ? '' : deliveryAdd,
                agentID: nextAgentId,
            });
        }catch(error) {
            console.log("error", error);
        }
    }

    async function handleDAOnSelect(value) {
        const bsOnsel = deliveryAddList.filter((items) => items.delivery_address.toUpperCase() === value.toUpperCase());
    }

    //DR number onBlur
    async function onBlurDrNum(payload) {
        const m0011 = messagesList.filter((items) => items.message_code === 'M0011');
        const drNum = payload.target.value;
        const checkInvNum = await fetchDeliveryHeaderAPI(drNum);

        if(checkInvNum.length > 0){
            Message.error({ message: m0011[0].message_display });
        }
    }

    //handle table data
    function handleTableData(payload){
        setDetailsData(payload);
        // keep a synchronous ref so submit handlers can read the latest payload immediately
        detailsDataRef.current = payload;
    }
    
    //handleDeleteList
     function handleDeleteList(payload){
        setDeleteList(prevList => [...prevList, payload]);
    }

    // handle get updated data
    async function handPushResult(){
        const getValues = form.getFieldValue();
        const dr_no = getValues.DrNo;

        try{
            // search by delivery number
            const result = await fetchDeliveryNoAPI(dr_no);
            return result;
        }catch(error) {
            return error;
        }
    }

    function handleSubmit(formValues) {        
        if(formValues.submit_val === 'post' && !formValues.drDate){
            form.setFields([
                {
                    name: 'drDate',
                    errors: ['Required Field'],
                },
            ]);
            return;
        }

        const handleFormVal = [formValues];
        const customer_val = customersList.filter((items) => items.customer_val === formValues.deliveredTo );

        const formValuesSubmit = handleFormVal.map(values => {
            return{
                ...values,
                drDate: ![undefined, null].includes(formValues.drDate) ? moment(formValues.drDate).format('YYYY/MM/DD') : null,
                customer_id: customer_val[0].customer_id,
            };
        });
       
        const m0003 = messagesList.filter((items) => items.message_code === 'M0003');
        const m0009 = messagesList.filter((items) => items.message_code === 'M0009');

        const chLineDesc = detailsData.filter(item => item.line_description === '');
        const chLineAmt = detailsData.filter(item => item.amount === 0);

        if(formValues.submit_val === 'post' && detailsData.length === 0){
            setCheckPost(false);

        }else if(formValues.submit_val === 'post' && detailsData.length > 0){
            // if(chLineDesc.length > 0 || chLineAmt > 0){
            //     setCheckPost(false);
            // }else{
            //     setCheckPost(true);
            // }
            setCheckPost(true);

        }else if(formValues.submit_val === 'save' && detailsData.length > 0) {
            if(chLineDesc.length > 0 || chLineAmt > 0){
                setCheckPost(false);
            }else{
                setCheckPost(true);
            }
        }else{
            setCheckPost(true);
        }

        // call modal
        if(formValues.submit_val === 'cancel'){
            Modal.confirm({
                title: m0009[0].message_title,
                icon: <ExclamationCircleOutlined />,
                content: m0009[0].message_display,
                okText: 'YES',
                cancelText: 'NO',
                onOk: ()=>{
                    handleConfirm(formValuesSubmit[0]);
                }
            });
        }else{
            Modal.confirm({
                title: m0003[0].message_title,
                icon: <ExclamationCircleOutlined />,
                content: m0003[0].message_display,
                okText: 'YES',
                cancelText: 'NO',
                onOk: ()=>{
                    handleConfirm(formValuesSubmit[0]);
                }
            });
        }
    };

    async function handleConfirm(formValues){
        const m0004 = messagesList.filter((items) => items.message_code === 'M0004');
        const m0005 = messagesList.filter((items) => items.message_code === 'M0005');
        const m0006 = messagesList.filter((items) => items.message_code === 'M0006');
        const m0007 = messagesList.filter((items) => items.message_code === 'M0007');
        const m0010 = messagesList.filter((items) => items.message_code === 'M0010');
        const m0011 = messagesList.filter((items) => items.message_code === 'M0011');
        // const m0014 = messagesList.filter((items) => items.message_code === 'M0014');
        const m0034 = messagesList.filter((items) => items.message_code === 'M0034');
        
        let chLineDescConfirm = [];
        const currentDetails = detailsDataRef.current || detailsData;
        if(formValues.submit_val === 'post' && currentDetails.length > 0){
            console.log("🚀 ~ handleConfirm ~ item.quantity :", currentDetails)
            chLineDescConfirm = currentDetails.filter(item => item.line_description === '' || item.line_description === '-'
                || item.quantity === '' || item.quantity === '0' || item.unit_name === '' || item.unit_name === '-'
             );
        }

        if(checkPost && chLineDescConfirm.length === 0){
            if(!props.isEditting){
                //create delivery
                try {
                    const payloadDetails = detailsDataRef.current || detailsData;
                    const normalizedDetails = payloadDetails.map(item => {
                        const rawLineDescription = String(item.line_description || '').trim();
                        const lineHeader = String(item.line_header || '').trim();
                        const baseDescription = rawLineDescription.split('|')[0].trim();
                        return {
                            ...item,
                            line_description: lineHeader
                                ? `${baseDescription} | ${lineHeader}`
                                : rawLineDescription,
                        };
                    });

                    console.log('📤 Creating delivery - formValues:', formValues);
                    console.log('📤 Creating delivery - normalizedDetails payload:', normalizedDetails);
                    const createRes = await createDeliveryAPI(formValues, normalizedDetails);
                    if(createRes.data.dr_id !== undefined){
                        if(formValues.submit_val === 'post'){
                            Message.success({ message: m0005[0].message_display });
                           const handlePush = await handPushResult();
                            navigate.push({
                                pathname: '/delivery/details_update',
                                state: {
                                    record: handlePush, 
                                },
                            });
                            window.location.reload();
                        
                        }else {
                            Message.success({ message: m0004[0].message_display });
                            const handlePush = await handPushResult();
                            navigate.push({
                                pathname: '/delivery/details_update',
                                state: {
                                    record: handlePush, 
                                },
                            });
                            window.location.reload();
                        }
                    }else{
                        const res = createRes.data;
                        if(res.name === 'error' && res.code === '23505'){
                            Message.error({ message: m0011[0].message_display });
                        }else{
                            if(res.detail !== undefined){
                                Message.error({ message: m0007[0].message_display });
                            }else{
                                Message.error({ message: m0007[0].message_display });
                            }
                        }
                    }
                }catch(error) {
                    console.log(error);
                    const apiMessage = getApiErrorMessage(error, m0007[0].message_display);

                    if (apiMessage.toLowerCase().includes('duplicate key') || apiMessage.toLowerCase().includes('already exists')) {
                        Message.error({ message: m0011[0].message_display });
                    } else {
                        Message.error({ message: apiMessage });
                    }
                }
            }else{
                //update Delivery Header
                try{
                    const updatePayload = {
                        ...formValues,
                        // Ensure backend receives the active editor identity for last_updated_by.
                        prepared_by: loggedinUser.userName,
                        updated_by: loggedinUser.userID,
                    };
                    // Filter out deleted items from detailsData before sending to update API
                    const deleteLineIds = deleteList.map(item => item.dr_line_id);
                    const filteredDetailsData = detailsData.filter(item =>
                        !item.dr_line_id || !deleteLineIds.includes(item.dr_line_id)
                    );

                    console.log('🗑️ Items marked for deletion:', deleteList);
                    console.log('🗑️ Delete line IDs:', deleteLineIds);
                    const logDetails = detailsDataRef.current || detailsData;
                    console.log('📤 Original detailsData:', (logDetails || []).map(d => ({key: d.key, dr_line_id: d.dr_line_id, line_description: d.line_description})));
                    console.log('📤 Filtered detailsData (for update API):', filteredDetailsData.map(d => ({key: d.key, dr_line_id: d.dr_line_id, line_description: d.line_description})));

                    console.log('📤 Updating delivery - updatePayload:', updatePayload);
                    console.log('📤 Updating delivery - filteredDetailsData payload:', filteredDetailsData);
                    const updateRes = await updateDeliveryAPI(updatePayload, filteredDetailsData);

                    if(updateRes.data.dr_id !== undefined){
                        // Delete items from database AFTER successful update
                        if(deleteList.length > 0){
                            console.log('🗑️ Deleting items from database:', deleteList.map(item => item.dr_line_id));

                            // Try multiple delete calls - one per item
                            for(const item of deleteList){
                                console.log('🗑️ Deleting dr_line_id:', item.dr_line_id);
                                try {
                                    const deleteResult = await deleteDrDetailsAPI(item.dr_line_id);
                                    console.log('✅ Delete successful for dr_line_id:', item.dr_line_id, 'Result:', deleteResult);
                                } catch(err) {
                                    console.error('❌ Delete failed for dr_line_id:', item.dr_line_id, 'Error:', err);
                                }
                            }

                            console.log('✅ All delete operations completed');

                            // Clear delete list after successful deletion
                            setDeleteList([]);
                        };
                        if(formValues.submit_val === 'post'){
                            Message.success({ message: m0005[0].message_display });
                            const handlePush = await handPushResult();
                            navigate.push({
                                pathname: '/delivery/details_update',
                                state: {
                                    record: handlePush,
                                },
                            });
                            window.location.reload(false);
                        }else if(formValues.submit_val === 'cancel') {
                            Message.success({ message: m0010[0].message_display });
                            const handlePush = await handPushResult();
                            navigate.push({
                                pathname: '/delivery/details_update',
                                state: {
                                    record: handlePush,
                                },
                            });
                            window.location.reload(false);
                        }else {
                            Message.success({ message: m0006[0].message_display });
                            const handlePush = await handPushResult();
                            navigate.push({
                                pathname: '/delivery/details_update',
                                state: {
                                    record: handlePush,
                                },
                            });
                            window.location.reload(false);
                        }

                    }else {
                        const res = updateRes.data;
                        Message.error({ message: m0007[0].message_display });
                    }
                }catch(error){
                    console.log(error);
                    const apiMessage = getApiErrorMessage(error, m0007[0].message_display);

                    if (apiMessage.toLowerCase().includes('duplicate key') || apiMessage.toLowerCase().includes('already exists')) {
                        Message.error({ message: m0011[0].message_display });
                    } else {
                        Message.error({ message: apiMessage });
                    }
                }
            }

        }else{
            Message.error({ message: m0034[0].message_display });
        }
    };

    function handleBack(){
        const m0008 = messagesList.filter((items) => items.message_code === 'M0008');
        const getValues = form.getFieldValue();
        
        const checkBackVal = form.getFieldsValue(null, meta => meta.touched);
        const backArr = Object.values(checkBackVal);

        if(edit){
            const m0008Title = m0008[0].message_title === undefined ? '' : m0008[0].message_title;
            const m0008Message = m0008[0].message_display === undefined ? 'Changes will be cancelled' : m0008[0].message_display;
            Modal.confirm({
                title: m0008Title,
                icon: <ExclamationCircleOutlined />,
                content: m0008Message,
                okText: 'YES',
                cancelText: 'NO',
                onOk: ()=>{ navigate.push('/delivery/search') }
            });

        }else{
            if(backArr.length > 0 ){
                if(getValues.status === 'POSTED' || getValues.status === 'CANCELLED'){
                    navigate.push('/delivery/search');
                }else {
                    const m0008Title = m0008[0].message_title === undefined ? '' : m0008[0].message_title;
                    const m0008Message = m0008[0].message_display === undefined ? 'Changes will be cancelled' : m0008[0].message_display;
                    Modal.confirm({
                        title: m0008Title,
                        icon: <ExclamationCircleOutlined />,
                        content: m0008Message,
                        okText: 'YES',
                        cancelText: 'NO',
                        onOk: ()=>{ navigate.push('/delivery/search') }
                    });
                }
            }else{
                navigate.push('/delivery/search');
            }

        }
    };


    async function handleRefresh(){
        
        if(props.isEditting){
            const handlePush = await handPushResult();
            navigate.push({
                pathname: '/delivery/details_update',
                state: {
                    record: handlePush, 
                },
            });
            window.location.reload(false);
        }else{
            window.location.reload(false);
        }
    };

    async function handlePrint(){
        setPrintLoading(true);
        try {
            const report_details = (()=>{

                const { formated_dr_date, dr_id, dr_no, status_id,status_name,customer_id,customer_name,delivery_address,agent_name,
                                contact_person, tel_no, mobile_no, po_no, term_id, term_name, total_amount, //=== '0.00' ? '' : drDetProps.total_amount,
                                prepared_by,prepared_by_username,checked_by,approved_by,delivered_by,remarks,created_by,created_date,last_updated_by,last_updated_date,
                } = drDetProps;

            let getCustomerName = ''
            if(props.isEditting){
                getCustomerName = customersList.filter(cust => cust.customer_id === drDetProps.customer_id)
            }

                if(drDetails.length > 0){

                    return drDetails.map(value => {
                        return {
                            formated_dr_date, dr_id,
                            dr_no,
                            dr_date: drDetProps.formated_dr_date,
                            status_id, status_name, customer_id,
                            customer: toUpper(getCustomerName[0].customer_name),
                            delivered_to: toUpper(getCustomerName[0].customer_name),
                            delivery_address: toUpper(drDetProps.delivery_address),
                            agent_name,
                            contact_person: toUpper(drDetProps.contact_person),
                            tel_no,
                            mobile_no,
                            po_no: `${drDetProps.po_no}/${drDetProps.term_name}`,
                            term_id,
                            term_name,
                            total_amount: formatAmountForPrint(drDetProps.total_amount),
                            prepared_by: drDetProps.prepared_by,
                            prepared_by_username: toUpper(drDetProps.prepared_by_username),
                            checked_by: drDetProps.checked_by,
                            approved_by: drDetProps.approved_by,
                            delivered_by: drDetProps.delivered_by,
                            remarks: drDetProps.remarks,
                            created_by: drDetProps.created_by,
                            created_date: drDetProps.created_date,
                            last_updated_by: drDetProps.last_updated_by,
                            last_updated_date: drDetProps.last_updated_date,
                            ...value,
                            quantity: formatQuantityForPrint(value.quantity),
                            // amount: value.amount === '0.00' ? '' : value.amount,
                            unit_price: value.unit_price === '0.00000000' ? '0.00' : value.unit_price,
                            unit_name: toUpper(value.unit_name),
                            line_description: toUpper(value.line_description)
                        };
                });
            }else{
                return( [{
                    formated_dr_date, dr_id, dr_no, status_id,status_name,customer_id,
                    customer: toUpper(getCustomerName[0].customer_name),
                    delivered_to: toUpper(getCustomerName[0].customer_name),
                    delivery_address: toUpper(delivery_address),agent_name,
                    contact_person: toUpper(contact_person), 
                    tel_no, mobile_no, 
                    po_no: `${drDetProps.po_no}/${drDetProps.term_name}`,
                    term_id, term_name,
                    total_amount: formatAmountForPrint(total_amount),
                    prepared_by,
                    prepared_by_username: toUpper(prepared_by_username),checked_by,approved_by,delivered_by,remarks,created_by,created_date,last_updated_by,last_updated_date,
                    key: '',
                    unit_id: '',
                    unit_name: '',
                    dr_line_id: '',
                    line_no: '',
                    quantity: '',
                    unit_price: '0.00',
                    line_description: '',
                }]
            );
               
            }
        })();
        
        const payload = {
			"xml_name": "PRT_DR",
            "report_name": toUpper(loggedinUser.userName),
			"report_details": report_details
        }
		
        const m0015 = messagesList.filter((items) => items.message_code === 'M0015');
        const getStatus = form.getFieldsValue().status;

        const normalizeLineDescription = (desc) => {
            const parts = String(desc || '').split('|').map(part => part.trim()).filter(part => part !== '');
            return parts.join(' | ');
        };

        let checkEdittedValues = false;
        if(props.isEditting){
            const compareDetails = detailsDataRef.current && detailsDataRef.current.length > 0 ? detailsDataRef.current : detailsData;
            const rowsMatch = drDetails.length === compareDetails.length && drDetails.every((drRow, index) => {
                const compareRow = compareDetails[index] || {};
                const drQuantity = parseFloat(drRow.quantity);
                const compareQuantity = parseFloat(String(compareRow.quantity || '').replace(/,/g, ''));
                const drUnitName = String(drRow.unit_name || '').trim();
                const compareUnitName = String(compareRow.unit_name || '').trim();
                const drLineDesc = normalizeLineDescription(drRow.line_description);
                const compareLineDesc = normalizeLineDescription(compareRow.line_description);
                const drUnitPrice = parseFloat(String(drRow.unit_price || '').replace(/,/g, ''));
                const compareUnitPrice = parseFloat(String(compareRow.unit_price || '').replace(/,/g, ''));
                const drAmount = parseFloat(String(drRow.amount || '').replace(/,/g, ''));
                const compareAmount = parseFloat(String(compareRow.amount || '').replace(/,/g, ''));

                return (
                    drQuantity === compareQuantity &&
                    drUnitName === compareUnitName &&
                    drLineDesc === compareLineDesc &&
                    drUnitPrice === compareUnitPrice &&
                    drAmount === compareAmount
                );
            });

            checkEdittedValues = !rowsMatch;
        }

            if(checkEdittedValues){
                Message.error({ message: m0015[0].message_display });
            }else{
                if(getStatus === 'CANCELLED'){
                    Message.error({ message: m0015[0].message_display });
                }else{
                    const handlePrint = await generateDeliveryReport(payload);
                    const pdf_file = handlePrint.records[0].pdf;
        
                    let pdfWindow = window.open("")
                    pdfWindow.document.write(
                        "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
                        encodeURI(pdf_file) + "'></iframe>"
                    )
                }
            }
        } catch (error) {
            console.error('Print error:', error);
            Message.error({ message: 'Error generating report' });
        } finally {
            setPrintLoading(false);
        }
    }

	const validateMessages = {
        required: 'Required Field',
    };

    const initialDrDate = (()=>{
        if(props.isEditting){
            if(drDetProps.formated_dr_date !== null){
                // catches null date
                return moment.utc(drDetProps.formated_dr_date, 'MM-DD-YYYY');
            }else{
                // returns undefined to be included in drDate
                return undefined;
            }
        }else{
            return undefined;
        }
    })();

    const handleEditOnClick = ((e)=> {
        // setDeliverToDisabled(false);
        // setAllDisabled(false);
        setEdit(true);
    })

	return isloading ? (
        <div className='spin-loading' >
            <Spin tip="Loading..." size='large'></Spin>
        </div>
    ) : 
        (
		<div>
			<Card>
				<PageTitle pageTitle="DELIVERY RECEIPT" />
				<Form onFinish= {handleSubmit} 
                      validateMessages={validateMessages} 
                       layout="vertical" form={form} 
                       className="delivery-dataentry-form"
                       form={form}
                >
					<Row gutter={[8, 1]} align="top">
						<Col span={4}>
							<Form.Item style={formItemStyle} name="DrNo" label="D.R NO."
							rules={[ {required: true} ]}
							initialValue={(props.isEditting) ? drDetProps.dr_no : ''}
							>
								<AlphaNumInput 
                                        disabled={(props.isEditting) ? true : false}
                                        className='inv-input-uppercase'
                                        placeholder="D.R NO."
                                        maxLength={50}
                                        onBlur={onBlurDrNum}
                                />
							</Form.Item>
						</Col>
						<Col span={4}>
                            <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.submit_val !== currentValues.submit_val}>
                                {({ getFieldValue }) => {
                                    const isPostMode = getFieldValue('submit_val') === 'post';

                                    return (
                                        <Form.Item style={formItemStyle} name="drDate" label="D.R DATE"
                                            required={isPostMode}
                                            dependencies={['submit_val']}
                                            rules={[
                                                ({ getFieldValue }) => ({
                                                    validator(_, value){
                                                        if(getFieldValue('submit_val') === 'post' && !value){
                                                            return Promise.reject(new Error('Required Field'));
                                                        }
                                                        return Promise.resolve();
                                                    },
                                                }),
                                            ]}
                                            initialValue={initialDrDate}
                                        >
                                            <DatePicker
                                                format="MM/DD/YYYY"
                                                // disabledDate={(current) => current.isAfter(moment())}
                                                style={{ width: '100%' }}
                                                disabled={edit ? false : allDisabled}
                                            />
                                        </Form.Item>
                                    );
                                }}
                            </Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item style={formItemStyle} name="status" label="STATUS"
							    initialValue={(props.isEditting) ? drStatus : 'NEW'}
							>
                                <Input disabled={true} />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item style={formItemStyle} name="deliveredTo" label="DELIVERED TO"
							rules={[ {required: true} ]}
							initialValue={(props.isEditting) ? drDetProps.customer_val : []}
							>
								<Select
									placeholder="CUSTOMER"
									showSearch
                                    filterOption={(input, option) => option.value.toLowerCase().startsWith(input.toLowerCase())}
                                    disabled={allDisabled}
									onChange={handleDeliverToOnChange}                                    
								>
									{deliverToOptions}
								</Select>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={[8, 1]} justify="space-around" align="top">
						<Col span={12}>
							<Form.Item style={formItemStyle} name="deliveryAddress" label="DELIVERY ADDRESS"
							rules={[ {required: true} ]}
							initialValue={(props.isEditting) ? drDetProps.delivery_address : ''}
							>
								<AutoComplete placeholder='DELIVERY ADDRESS' style={{width:'100%'}}
                                    disabled={deliverToDisabled}
                                    onSelect={handleDAOnSelect}
                                    maxLength={200}
								>
                                   {addressOptions}
                                 </AutoComplete>
							</Form.Item>
						</Col>
						<Col span={4}>
                            <Form.Item style={formItemStyle} name="agentID" label="AGENT"
                            rules={[ {required: true} ]}
                            initialValue={(props.isEditting) ? drDetProps.agent_id : undefined }
                            >
                                <Select
                                    disabled={allDisabled}
                                    placeholder={'AGENT'}
                                    showSearch
                                    filterOption={
                                        (input, option) => option.agentName.toLowerCase().startsWith(input.toLowerCase())
                                    }
                                >
                                    {agentsOptions}
                                </Select>
                            </Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item style={formItemStyle} name="poNumber" label="PO NUMBER"
							    initialValue={(props.isEditting) ? drDetProps.po_no : ''}
                            >
                                <Input 
                                    className='dr-input-uppercase'
                                    placeholder="PO NUMBER"
                                    disabled={allDisabled}
                                    maxLength={50}
                                />
							</Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item style={formItemStyle} name="terms" label="TERMS"
							initialValue={(props.isEditting) ? drDetProps.term_id : []}
							>
								<Select 
                                    disabled={deliverToDisabled}
									placeholder="TERMS"
									showSearch
									filterOption={(input, option) =>
										option.children.toLowerCase().includes(input.toLowerCase())
									}
								>
									{termsOptions}
								</Select>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={[8, 1]}>
						<Col span={6}>
							<Form.Item name="prepared_by" label="PREPARED BY"
							  initialValue={(props.isEditting) 
								? drDetProps.prepared_by_username 
								: loggedinUser.userName
							}
							
							>
							    <Input className='dr-input-uppercase' 
                                    placeholder="PREPARED BY" 
                                    disabled
                                    maxLength={100}
                                />
							</Form.Item>
						</Col>
						<Col span={6}>
							<Form.Item //style={formItemStyle} 
                            name="checkedBy" label="CHECKED BY"
							initialValue={(props.isEditting) ? drDetProps.checked_by : ''}
							>
                                <RegexInput 
                                   className='dr-input-uppercase'
                                   placeholder="CHECKED BY"
                                   disabled={allDisabled}
                                   maxLength={50}
                                   regex={/^[ A-Za-z0-9]*$/} />
							</Form.Item>
						</Col>
						<Col span={6}>
							<Form.Item //style={formItemStyle} 
                            name="deliveredBy" label="DELIVERED BY"
							initialValue={(props.isEditting) ? drDetProps.delivered_by : ''}
							>
                                <RegexInput 
                                    className='dr-input-uppercase'
                                    placeholder="DELIVERED BY"
                                    disabled={allDisabled}
                                    maxLength={50}
                                    regex={/^[ A-Za-z0-9]*$/} 
                                />
							</Form.Item>
						</Col>
						<Col span={6}>
							<Form.Item //style={formItemStyle} 
                            name="approvedBy" label="APPROVED BY"
							initialValue={(props.isEditting) ? drDetProps.approved_by : ''}
							>
                                <RegexInput 
                                    className='dr-input-uppercase'
                                    placeholder="APPROVED BY"
                                    disabled={allDisabled}
                                    maxLength={50}
                                    regex={/^[ A-Za-z0-9]*$/} 
                                />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={[8, 1]} align='bottom'>
						<Col span={12}>
							<Form.Item //style={formItemStyle} 
                            name="remarks" label="REMARKS"
							initialValue={(props.isEditting) ? drDetProps.remarks : ''}
							>
                                <Input className='dr-input-uppercase' 
                                    placeholder="REMARKS" 
                                    disabled={allDisabled}
                                    maxLength={100}
                                />
							</Form.Item>
						</Col>
						<Col span={6}>
							<Form.Item style={formItemStyle} 
								name="totalAmount" 
								label="TOTAL AMOUNT"
								initialValue={(props.isEditting) ? drDetProps.total_amount : 0}
							>
								<Input placeholder="0.00" disabled />
							</Form.Item>
						</Col>
					</Row>
					<DeliveryDataTable 
					        drDetails={ drDetails }
                            drData ={ drData } 
                            handleTotVal = { handleTotVal }
                            handleTableData = { handleTableData }
                            disabled={allDisabled}
                            messagesList={messagesList}
                            handleDeleteList={handleDeleteList}
                            edit={edit}
					/>
					<Row gutter={[8, 1]} justify="space-around">
						<Col className="button-below" span={12}>
                            {(props.isEditting) && (printDRRight === 'TRUE') 
                                ?   <Button //style={buttonStyle} 
                                        className="dr-button" type="primary" icon={<PrinterOutlined />}
                                        disabled={props.isEditting && drStatus === 'CANCELLED' ? allDisabled : false}
                                        loading={printLoading}
                                        onClick={handlePrint}
                                        >
                                            {drStatus === 'NEW' ? 'PRINT PREVIEW' : (printLoading ? 'PRINTING...' : 'PRINT')}
                                        </Button>
                                : <></>
                            }
    
							<Button //style={buttonStyle} 
                                className="dr-button" type="primary" icon={<SyncOutlined />}
                                disabled={props.isEditting && drStatus === 'CANCELLED' ? allDisabled : false}
                                onClick={handleRefresh}
                            >
								REFRESH
							</Button>
						</Col>
						<Col className="button-below" span={12}>
						<Form.Item name="submit_val">
							<div style={footerStyleRight}>
								<Button
                                    classname = "dr-button"
									type="primary"
									icon={<RollbackOutlined />}
									onClick={handleBack}
								>
									BACK
								</Button>
                                {(props.isEditting) && (cancelDRRight === 'TRUE')
                                    ?   <Button 
                                            className="dr-button" 
                                            type="primary" icon={<StopOutlined />}
                                            htmlType='submit'
                                            onClick={()=> { form.setFieldsValue({submit_val: 'cancel'}) 
                                                            setCheckPost(true);
                                                        }
                                                    }
                                            disabled={drStatus === 'CANCELLED' ? allDisabled : false}
                                        >
                                            CANCEL DR
                                        </Button> 
                                    : <></>
                                }

                                {( props.isEditting && drStatus === 'POSTED' && overrideDRRight === 'TRUE')
                                ?   <Button
                                        type="primary"
                                        onClick={handleEditOnClick}
                                    >EDIT</Button>
                                :   <></>
                                }

                                <Button //style={buttonStyle} 
                                    className="dr-button" 
                                    type="primary" 
                                    icon={<SaveOutlined />}
                                    htmlType='submit'
                                    onClick={()=> { form.setFieldsValue({submit_val: 'save'}) 
                                                    // const getValues = form.getFieldValue();
                                                    setCheckPost(true);
                                                    
                                                    // if(getValues.submit_val === 'save' && detailsData.length > 0) {
                                                    //     const chLineDesc = detailsData.filter(item => item.line_description === '-');
                                                    //     const chLineAmt = detailsData.filter(item => item.amount === 0);
                                            
                                                    //     if(chLineDesc.length > 0 || chLineAmt > 0){
                                                    //         setCheckPost(false);
                                                    //     }else{
                                                    //         setCheckPost(true);
                                                    //     }
                                                    // }else{
                                                    //     setCheckPost(true);
                                                    // }
                                                }
                                            }
                                            disabled={edit ? false : allDisabled}
                                >
                                    SAVE
                                </Button>

                                {(postDRRight === 'TRUE') ?
                                    <Button 
                                        //style={buttonStyle} -----------
                                        type="primary" 
                                        icon={<SnippetsOutlined />}
                                        className="dr-button" 
                                        htmlType='submit'
                                        onClick={()=> { form.setFieldsValue({submit_val: 'post'}) 
                                            const getValues = form.getFieldValue();

                                            const chLineDesc = detailsData.filter(item => item.line_description === '-');
                                            const chLineAmt = detailsData.filter(item => item.amount === 0);
                                     
                                            if(getValues.submit_val === 'post' && detailsData.length === 0){
                                                setCheckPost(false);
                                            }else if(getValues.submit_val === 'post' && detailsData.length > 0){
                                                if(chLineDesc.length > 0 || chLineAmt > 0){
                                                    setCheckPost(false);
                                                }else{
                                                    setCheckPost(true);
                                                }
                                            }else{
                                                setCheckPost(true);
                                            }
                                        }}
                                        disabled={edit ? true : (drStatus === 'POSTED' || drStatus === 'CANCELLED' || !postDRRight)}
                                    >
                                        POST
                                    </Button>
                                    : <></>
                                }
								
							</div>
							</Form.Item>
						</Col>
					</Row>
				</Form>
			</Card>
		</div>
	);
}
